import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function FivetranIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Box
        as="path"
        fill="#0073FF"
        d="M12.75 10h2a.313.313 0 0 0 .313-.313c0-.03 0-.093-.032-.124L11.594.187C11.53.095 11.438 0 11.313 0h-2A.313.313 0 0 0 9 .313c0 .03 0 .062.031.093L12.5 9.844c.031.094.125.156.25.156Zm-.344 10h2a.313.313 0 0 0 .313-.313c0-.03 0-.062-.031-.093L7.561.187C7.532.095 7.407 0 7.282 0h-2a.313.313 0 0 0-.313.313c0 .03 0 .062.031.093l7.125 19.407c.031.125.156.187.281.187Zm-3.968 0h2c.156 0 .28-.125.312-.281 0-.032 0-.094-.031-.125L7.25 10.187c-.031-.124-.156-.187-.281-.187H4.937c-.156 0-.28.156-.28.313 0 .03 0 .062.03.093l3.438 9.406c.094.125.188.188.313.188ZM13 .406l1.625 4.407c.031.125.156.187.281.187h1.969a.313.313 0 0 0 .313-.313c0-.03 0-.062-.032-.093L15.531.187a.272.272 0 0 0-.25-.187h-2a.313.313 0 0 0-.312.313c0 .03 0 .062.031.093ZM4.75 20h2a.313.313 0 0 0 .313-.313c0-.03 0-.062-.032-.093l-1.625-4.407C5.375 15.063 5.25 15 5.125 15h-2a.313.313 0 0 0-.313.313c0 .03 0 .062.032.093l1.625 4.406c.031.125.156.188.281.188Z"
      />
    </Icon>
  );
}
